import { useState } from "react"
import { useUIHelper } from "../../../biz/hooks/ui/useUIHelper"
import { Form, FormButton, FormField, FormInput } from "../../forms/FormElements"
import { ScreenTemplate } from "./ScreenTemplate"
import { useTranslation } from "react-i18next"

export const Tests = () => {
    const { t } = useTranslation();
    return (
        <ScreenTemplate header={t("tests")} text="Test <form>">
            <div>
                <Frm />
            </div>

        </ScreenTemplate>
    )
}

type FormType = {
    txt: string
    txt2: string
    txt3: string
    txt4: string,
    num?: number
    dte?: number
    time?: number
    color?: string,
    month?: number
    checkbox?: boolean
    select?: string
}
const formDefault = { txt: "", txt2: "", txt3: "", txt4: "", color: "#fff" };

const Frm = () => {
    const [values, setValues] = useState<FormType>(formDefault);
    const ui = useUIHelper();

    const [color, setColor] = useState<string>("");

    const { t } = useTranslation();

    return (
        <div>
            <Form>
                <FormField label={t("text")}>
                    <FormInput name={''} label={''} type={'text'}
                        valueChanged={e => { setValues({ ...values, txt3: e }) }} value={values?.txt3}
                        placeholder={t("text")}
                    />
                </FormField>


                <FormField label={t("number")}>
                    <input type="number" min={0} max={100} step={0.5}
                        onChange={e => setValues({ ...values, num: e.target.valueAsNumber })}
                        value={values?.num}
                        placeholder={t("number")}
                    />
                </FormField>

                <FormField label={t("date")}>
                    <input type="date"
                        onChange={e => {
                            setValues({ ...values, dte: e.target.valueAsNumber });
                        }}
                    //value={values?.dte}
                    />
                </FormField>


                <FormField label={t("time")}>
                    <input type="time"
                        onChange={e => {
                            setValues({ ...values, time: e.target.valueAsNumber });
                        }}
                    // value={values?.time}
                    />
                </FormField>

                {/* <FormField label='Color'>
                <input type="color" onChange={e => {
                    setColor(e.target.value);
                    setValues({ ...values, color: e.target.value })
                }}
                    value={values?.color}

                    style={{ width: "80%" }} />
                <div style={{ display: "inline-block", height: "30px", width: "20%", borderRadius: 20, backgroundColor: color }}>&nbsp;</div>
            </FormField> */}

                <FormField label={t("month")}>
                    <input type="month"
                        onChange={e => setValues({ ...values, month: e.target.valueAsNumber })}
                    // value={values?.month} 
                    />
                </FormField>

                <FormField label='Checkbox'>
                    <input type="checkbox"
                        onChange={e => setValues({ ...values, checkbox: e.target.checked })}
                        checked={values?.checkbox}
                    />
                </FormField>

                <FormField label={t("select")}>
                    <select
                        onChange={e => setValues({ ...values, select: e.target.value })}
                        value={values?.select}>
                        <option value="1">001</option>
                        <option value="2">002</option>
                        <option value="3">003</option>
                        <option value="4">004</option>
                        <option value="5">005</option>
                        <option value="6">006</option>
                        <option value="7">007</option>
                    </select>
                </FormField>

                <FormField label=''>
                    <FormButton
                        label={t("push")}
                        onClick={() => setValues(formDefault)}
                    />
                </FormField>

            </Form>

            <div>
                <div>
                    {JSON.stringify(values)}
                </div>
            </div>

            {/* <div>
                <pre>
                    export interface IResource {'{'}
                    {Object.keys(Resource_sv).map(n => (
                        <div key={n}>
                            &nbsp;&nbsp;&nbsp;{n}: string
                        </div>
                    ))}
                    {'}'}
                </pre>

            </div> */}
        </div>
    )
}

